import React from 'react'
import { cn } from '#app/utils/misc.js'

export const DropdownCategoryTitle = ({
	children,
}: {
	children: React.ReactNode
}) => {
	return (
		<div className="mb-1 px-1.5 text-[.65rem] font-semibold uppercase text-neutral-500">
			{children}
		</div>
	)
}

export const DropdownButton = React.forwardRef<
	HTMLButtonElement,
	{
		children: React.ReactNode
		isActive?: boolean
		onClick?: () => void
		disabled?: boolean
		className?: string
	}
>(function DropdownButtonInner(
	{ children, isActive, onClick, disabled, className },
	ref,
) {
	const buttonClass = cn(
		'flex w-full items-center gap-2 rounded bg-transparent p-1.5 text-left text-sm font-medium text-neutral-500',
		!isActive && !disabled,
		'hover:bg-neutral-100 hover:text-neutral-800',
		isActive && !disabled && 'bg-neutral-100 text-neutral-800',
		disabled && 'cursor-not-allowed text-neutral-400',
		className,
	)

	return (
		<button
			className={buttonClass}
			disabled={disabled}
			onClick={onClick}
			ref={ref}
		>
			{children}
		</button>
	)
})
